<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-form @submit="onSubmit">
        <b-form-group :label="$t('tuevs.method.form.fields.codigo.label')" label-for="input-codigo">
          <b-form-input id="input-codigo" v-model="method.code" type="text"/>
        </b-form-group>
        <b-form-group :label="$t('tuevs.method.form.fields.nome.label')" label-for="input-name">
          <b-form-input id="input-name" v-model="method.name" type="text"/>
        </b-form-group>

        <b-form-group
            :label="$t('tuevs.method.form.fields.status.label')"
            label-for="input-status"
            :description="$t('tuevs.method.form.fields.status.description')"
        >
          <b-form-checkbox id="input-status" v-model="method.status" size="lg" switch/>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('tuevs.method.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import MethodRepository from '@/repositories/tuevs/MethodRepository'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient
  },
  data() {
    return {
      method_id: null
    }
  },
  computed: {
    ...mapGetters({
      method: 'tuevs/method/current',
      isLoading: 'tuevs/method/isLoading'
    }),
    pageTitle() {
      if (this.method_id) return this.$t('tuevs.method.form.titulo_pagina.editar')
      return this.$t('tuevs.method.form.titulo_pagina.criar')
    }
  },
  methods: {
    ...mapActions([
      'tuevs/method/listOne'
    ]),
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      MethodRepository.post(this.method).then(() => {
        this.$snotify.success(this.$t('tuevs.method.form.create.success'))
        this.$router.push({name: 'tuevs.method'})
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.method.form.create.error'))
        if (error.response.status === 422) {
          MethodRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      MethodRepository.put(this.method_id, this.method).then(() => {
        this.$snotify.success(this.$t('tuevs.method.form.update.success'))
        this.$router.push({name: 'tuevs.method'})
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.method.form.update.error'))
        if (error.response.status === 422) {
          MethodRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    this.$store.commit('tuevs/method/setCurrent', {status: false})
    if (this.$route.params.id) {
      this.method_id = this.$route.params.id
      await this['tuevs/method/listOne'](this.$route.params.id)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
